export default "__VITE_ASSET__e6a3dfcd__"